<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    hide-overlay
    :max-width="$vuetify.breakpoint.smAndDown ? '100%' : '60%'"
    transition="dialog-bottom-transition"
  >
    <v-card class="news-container" v-if="noticia">
      <v-toolbar
        flat
        class="tool-bar"
        style="background-color:rgba(0,0,0,.0); position: absolute; z-index:145; width:100%"
      >
        <v-btn fab small color="white" @click="close()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title></v-toolbar-title>
      </v-toolbar>

      <v-img
        style="filter: blur(5px);position:absolute"
        gradient="to top, rgba(0,0,0,.53), rgba(25,32,72,.2)"
        :src="image"
        width="100%"
        max-height="350px"
      />

      <v-img
        contain
        gradient="to top, rgba(0,0,0,.53), rgba(25,32,72,.2)"
        :src="image"
        width="100%"
        max-height="350px"
      >
        <div class="noticia-title white--text pb-2">
          <h2 v-if="!$vuetify.breakpoint.smAndDown">{{ noticia.title }}</h2>
          <h5 v-else>{{ noticia.title }}</h5>

          <span class="tag white--text ml-2">{{ noticia.tag }}</span>
          <span class="body-2 white--text ml-2">
            {{ new Date(noticia.date).toLocaleDateString() }}
          </span>
        </div>
      </v-img>

      <v-divider></v-divider>

      <div class="body-2 noticia grey-2">
        <h6 class="mb-4">Noticia</h6>
        <div v-html="noticia.content" />
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import $ from "jquery";
export default {
  name: "News",
  data: () => ({
    notifications: false,
    sound: true,
    widgets: false,
    publicPath: $(location).attr("origin") + "/archivos/noticias/"
  }),
  props: {
    dialog: Boolean,
    noticia: Object,
    close: Function
  },
  computed: {
    image() {
      return this.publicPath + this.noticia.image;
    }
  },
  watch: {
    noticia: function(newNotica) {
      // console.warn(newNotica);
    }
  }
};
</script>
<style lang="scss">
.v-dialog__content {
  z-index: 2002 !important;
}
</style>
<style lang="scss" scoped>
@import "@/assets/styles/global";
h6 {
  border-left: $green solid 4px;
  padding-left: 5px;
}
.noticia {
  padding: 20px 2vw 20px 2vw;
  // overflow-y: scroll;
}
.noticia-title {
  position: absolute;
  padding: 20px 2vw 20px 2vw;
  bottom: 0;
}
.news-container {
  max-height: 85vh;
  min-height: 65vh;
  overflow-y: scroll;
}
.tool-bar {
  border-radius: 0 !important;
}
</style>
